"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _usePresenterAddedToChimeSLI = require("./usePresenterAddedToChimeSLI");
Object.keys(_usePresenterAddedToChimeSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _usePresenterAddedToChimeSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _usePresenterAddedToChimeSLI[key];
    }
  });
});
var _useContentUploadedSLI = require("./useContentUploadedSLI");
Object.keys(_useContentUploadedSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useContentUploadedSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useContentUploadedSLI[key];
    }
  });
});
var _useLoadReadinessCheckerSLI = require("./useLoadReadinessCheckerSLI");
Object.keys(_useLoadReadinessCheckerSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLoadReadinessCheckerSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useLoadReadinessCheckerSLI[key];
    }
  });
});
var _useBackgroundUploadedOnStageSLI = require("./useBackgroundUploadedOnStageSLI");
Object.keys(_useBackgroundUploadedOnStageSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBackgroundUploadedOnStageSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBackgroundUploadedOnStageSLI[key];
    }
  });
});
var _useStreamSLI = require("./useStreamSLI");
Object.keys(_useStreamSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useStreamSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useStreamSLI[key];
    }
  });
});
var _useRecordingSLI = require("./useRecordingSLI");
Object.keys(_useRecordingSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRecordingSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useRecordingSLI[key];
    }
  });
});
var _useAttendeeUsedBackgroundFilterSLI = require("./useAttendeeUsedBackgroundFilterSLI");
Object.keys(_useAttendeeUsedBackgroundFilterSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useAttendeeUsedBackgroundFilterSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useAttendeeUsedBackgroundFilterSLI[key];
    }
  });
});
var _useFileUploadAction = require("./useFileUploadAction");
Object.keys(_useFileUploadAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useFileUploadAction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useFileUploadAction[key];
    }
  });
});
var _useScreenShareStartedAction = require("./useScreenShareStartedAction");
Object.keys(_useScreenShareStartedAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useScreenShareStartedAction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useScreenShareStartedAction[key];
    }
  });
});